import React from 'react';
import { safeFormObjects } from '../state/state';
import FormLinkDescription from './FormLinkDescription';

const FormLinkListItems = ({
  canEdit,
  code,
  field,
  items,
  showItem,
}) => (
  safeFormObjects(items, field).map((item, index) => {
    const key = `form_link_list_item_${code}_${item.text}_${item.link}_${index}`;
    return (
      <FormLinkDescription
        canEdit={canEdit}
        className="aridhia-form-link-list-item"
        key={key}
        field={field}
        showEdit={() => showItem(index)}
        text={item}
        toolTip={index > 1 ? 'top right' : 'left center'}
      />
    );
  })
);

export default FormLinkListItems;
